<template>
  <Row>
    <Col v-if="false" span="24">
    <p class="kanbanDes">
      <label>在线车辆</label><span>{{ onLine }}台</span><label>总车辆</label><span>{{ total }}台</span>
    </p>
    </Col>
    <div id="wavewrap">
      <qiuqiu :percent="percent" :size="120" :trail-width="10" trail-color="#163358" :stroke-width="10"
        stroke-color="#3ebaf7">
        <p style="font-size: 24px; margin-top: 36px; color: #fff">
          {{ percent }}
        </p>
        <p style="color: #fff">出车率/%</p>
      </qiuqiu>
    </div>
    <Col span="24">
    <Row style="text-align: center">
      <Col span="12">
      <h2 class="ewlcrrw">{{ driving }}</h2>
      <p>空闲</p>
      </Col>
      <Col span="12">
      <h2 class="ewlcrrw">{{ stay }}</h2>
      <p>出车中</p>
      </Col>
  
    </Row>
    </Col>
  </Row>
</template>
<script>
import qiuqiu from "./qiuqiu.vue";
export default {
  components: { qiuqiu },
  data() {
    return {
      onLine: 0,
      parking: 0,
      total: 0,
      item: {},
      offline: 0,
      unactivated: 0,
      stay: 0,
      percent: 0,
      driving: 0
    };
  },
  methods: {
    

    getData() {

      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-dpc/board/countCarState",
        data: this.item,
      }).then((res) => {
        var data = res.data.data;

        
        var obj = {
          0: {
            name: '空闲',
            list: []
          }, 1: {
            name: '任务中',
            list: []
          }
        }
        for (let i = 0; i < data.length; i++) {
          obj[data[i].state].list.push(data[i]);
        }
        
        this.onLine = 43;
        this.parking = 12;
        this.driving = obj[0].list.length;
        this.total = data.length;
        this.offline = 7;
        this.stay = obj[1].list.length;
        this.percent = this.zaixianlv(this.stay);
        this.unactivated = 3;

      });
    },
    zaixianlv(t) {
      var x;
      var d = (t / this.total) * 100;
      x = d.toFixed(2);
      return x;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="">
h2.ewlcrrw {
  font-size: 20px;
  font-weight: bold;
}
#wavewrap{
  width: 120px;
  height: 120px;
  margin: 20px auto 30px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/saodiche.vue